import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Input } from '$components/basic/Input';
import Grid from '$components/layout/Grid';
import { Container, TitleStyled, SubscriberBarButton } from './styled';
import baseApi from './api';

const { Row, Col } = Grid;

export default class SubscriberBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      emailError: false,
      reminderSuccess: false,
    };

    const { apiKey, consumerApiUrl } = this.props;
    const ApiInit = baseApi(apiKey, consumerApiUrl, (data) => this.setParentState(data), 'authkey');
    this.api = new ApiInit();
  }

  setParentState = (data) => this.setState(data);

  render() {
    const { email, emailError, reminderSuccess } = this.state;

    const { source } = this.props;

    const { setReminder } = this.api;

    return (
      <Container className="restricted">
        {!reminderSuccess && (
          <Row>
            <Col lg={{ span: 7 }} xs={{ span: 12 }}>
              <TitleStyled className="subscriber-bar">
                Subscribe to our mailing list to receive the latest updates and offers
              </TitleStyled>
            </Col>
            <Col lg={{ span: 3 }} xs={{ span: 8 }}>
              <Input
                name="email"
                placeholder="Your email address"
                label="Your email address"
                floating={email.length > 0}
                value={email}
                onChange={(e) => this.setState({ email: e.target.value })}
                className={classNames('email input', emailError ? 'input-error' : '')}
              />
              {emailError && <div className="error-input-message">Please enter a correct email</div>}
            </Col>
            <Col lg={{ span: 2 }} xs={{ span: 4 }} className="susbcribe-container">
              <SubscriberBarButton
                size="large"
                type="primary"
                onClick={() => setReminder(email, 'placeholder', source, 'subscribe')}
              >
                Subscribe
              </SubscriberBarButton>
            </Col>
          </Row>
        )}

        {reminderSuccess && (
          <TitleStyled>You&#39;ve been successfully subscribed to our mailing list</TitleStyled>
        )}
      </Container>
    );
  }
}

SubscriberBar.propTypes = {
  apiKey: PropTypes.string.isRequired,
  consumerApiUrl: PropTypes.string.isRequired,
  source: PropTypes.string.isRequired,
};
